import { takeLatest } from 'redux-saga/effects'

import { GET_DATA } from '../types'

import { getTextsWorker } from './worker'

export function* watchTexts() {
  yield takeLatest(GET_DATA, getTextsWorker)
}
